export const columns: any[] = [
  {
    title: '序号',
    dataIndex: 'index',
    align: 'left',
    width: 80,
  },
  {
    title: '任务名称',
    dataIndex: 'taskName',
    align: 'left',
    width: 150,
  },
  {
    title: '所属站点',
    dataIndex: 'stationName',
    align: 'left',
    width: 150,
  },
  {
    title: '线路里程',
    dataIndex: 'totalMileage',
    align: 'left',
    width: 150,
  },
  {
    title: '持续时间',
    dataIndex: 'duration',
    align: 'left',
    width: 150,
  },
  {
    title: '状态',
    dataIndex: 'taskStatus',
    align: 'left',
    width: 150,
  },
  {
    title: '操作',
    dataIndex: 'operation',
    align: 'left',
    width: 150,
  },
];
